//import "./App.css";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

import MainRouter from "./MainRouter";
import NavSideBar from "./components/SideBars/NavSideBar";
import TitleBar from "./components/NavBars/TitleBar";
import LoginPage from "./Pages/Login/LoginPage";
import DialogBoxYesNo from "./components/Dialog/DialogBoxYesNo";
import { useEffect, useState } from "react";
import handleRefreshToken from "./AppHandleRefreshToken";
import { clearCacheData, getStorageItem } from "./Common/Utility";
import { Post } from "./Common/WebRequest";
import PasswordRecoveryForm from "./Pages/PasswordRecovery/PasswordRecoveryForm";
import EmailSent from "./Pages/PasswordRecovery/EmailSent";
import PasswordResetForm from "./Pages/PasswordRecovery/PasswordResetForm";
import PasswordResetInvalid from "./Pages/PasswordRecovery/PasswordResetInvalid";

const TwoHour = 2 * 60 * 60 * 1000; // Refresh Token

//const Sec10 = 6 * 1000; // Refresh Token

function getLoginData() {
  try {
    return JSON.parse(localStorage.getItem("login"));
  } catch {
    return null;
  }
}

function App() {
  const [loginData, setLoginData] = useState(() => getLoginData());
  const [marginLeft, setMarginLeft] = useState("295px");
  const [width, setWidth] = useState("291px");
  const [userLogout, setUserLogout] = useState(false);
  // Function to clear complete cache data

  useEffect(() => {
    setLoginData(getLoginData());
  }, []);

  const handleNavToggle = (isLogout) => {
    setUserLogout(isLogout);
    if (isLogout) {
      setMarginLeft("0px");
      setWidth(0);
      return;
    }
    if (marginLeft === "295px") {
      //setMarginLeft("103px");
      //setWidth("90px");

      setMarginLeft("0px");
      setWidth("0px");
    } else {
      setMarginLeft("295px");
      setWidth("291px");
    }
  };

  useEffect(() => {
    clearCacheData();
    const data = getLoginData();
    if (data && data.token !== "") {
      const intervalId = setInterval(handleRefreshToken, TwoHour);
      return () => clearInterval(intervalId);
    }
  }, [loginData]);

  const navigate = useNavigate();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const handleRequestLogout = () => setShowLogoutDialog(true);

  const handleCloseLogoutDialog = (result) => {
    setShowLogoutDialog(false);
    if (result === true) handleLogoutConfirm();
  };

  const handleLogoutConfirm = async () => {
    try {
      const loginDataIdentifier = await getStorageItem(
        "login",
        "loginDataIdentifier"
      );
      await Post("Login/Logout", loginDataIdentifier);
      localStorage.removeItem("login");
      setLoginData(null);
      handleNavToggle(true);
      navigate("/login");
    } catch (err) {
      console.log("Error on logout:", err?.toString?.());
    }
  };

  // Check if the current route is "/passwordrecovery"

  const isPasswordRecoveryRoute =
    window.location.pathname === "/passwordrecovery";

  const isEmailSentRoute = window.location.pathname === "/emailsent";
  const isPasswordResetRoute = window.location.pathname === "/passwordreset";
  const isPasswordResetInvalid =
    window.location.pathname === "/PasswordResetInvalid";

  if (isPasswordRecoveryRoute) {
    return <PasswordRecoveryForm />;
  }
  if (isEmailSentRoute) {
    return <EmailSent />;
  }
  if (isPasswordResetRoute) {
    return <PasswordResetForm />;
  }

  if (isPasswordResetInvalid) {
    return <PasswordResetInvalid />;
  }

  if (!loginData || loginData.token === "") {
    console.log("Not logged");

    return (
      <div className="App">
        <div style={{ marginLeft: "1px" }}></div>

        <LoginPage onNavToggle={handleNavToggle} />
        <NavSideBar width="0px" />
      </div>
    );
  } else {
    return (
      <>
        {showLogoutDialog &&
          createPortal(
            <DialogBoxYesNo
              title="Abmelden"
              text="Sind Sie sicher, dass Sie sich abmelden möchten?"
              onClose={handleCloseLogoutDialog}
              showLogoutIcon
            />,
            document.body
          )}
        <div className="App">
          <div>
            <NavSideBar
              width={width}
              onRequestLogout={handleRequestLogout}
            />
          </div>
          <div
            style={{
              marginLeft: marginLeft,
              marginRight: "1px",
              paddingLeft: "1px",
            }}
          >
            <TitleBar
              onNavToggle={handleNavToggle}
              onRequestLogout={handleRequestLogout}
            />
            <div style={{ paddingLeft: "15px" }}>
              <MainRouter />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;
